module.exports = __webpack_public_path__ + "img/judge.da3c6ae9.svg";